import React from "react";
import { Outlet } from "react-router-dom";
import { GlobalHead } from "./components/Heads/GlobalHead.tsx";
import { Header } from "./components/Header/Header.tsx";

export const RootLayout: React.FC = () => {
  return (
    <>
      <GlobalHead />
      <Header />
      <Outlet />
    </>
  );
};
